import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { MainLayout } from '@/components/layout';
import { ROUTES } from '@/constants';
import { RequireAuth, RequireMenuTypeSelection } from '@/routes/common/guards';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';
import { authRoutes } from '@/routes/modules/auth';
import { userRoutes } from '@/routes/modules/user';
import { contentRoutes } from '@/routes/modules/content';
import { startupMessageRoutes } from '@/routes/modules/startup-message';
import { adminAccountRoutes } from '@/routes/modules/admin-account';
import { notificationRoutes } from '@/routes/modules/notification';
import { familyMemberRoutes } from '@/routes/modules/family-user.tsx';
import { sutraRoutes } from '@/routes/modules/sutra.tsx';
import { columnRoutes } from '@/routes/modules/column';
import { columnCategoryRoutes } from './modules/column-category';
import { copySutraRoutes } from './modules/copy-sutra';
// Lazy load pages
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const FormTest = lazy(() => import('@/pages/FormTest'));

// Route configuration
export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <RequireAuth>
        <RequireMenuTypeSelection>
          <MainLayout />
        </RequireMenuTypeSelection>
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={ROUTES.DASHBOARD} replace />,
      },
      {
        path: 'dashboard',
        element: (
          <SuspenseWrapper>
            <Dashboard />
          </SuspenseWrapper>
        ),
      },
      // Reservation routes sẽ xóa
      {
        path: 'form-test',
        element: (
          <SuspenseWrapper>
            <FormTest />
          </SuspenseWrapper>
        ),
      },
      // Module routes
      userRoutes,
      contentRoutes,
      startupMessageRoutes,
      adminAccountRoutes,
      notificationRoutes,
      familyMemberRoutes,
      sutraRoutes,
      columnRoutes,
      columnCategoryRoutes,
      copySutraRoutes,
      // Course routes sẽ xóa
      {
        path: 'courses/*',
        element: (
          <SuspenseWrapper>
            <Dashboard />
          </SuspenseWrapper>
        ),
      },
      // Reservation routes sẽ xóa
      {
        path: 'reservations/*',
        element: (
          <SuspenseWrapper>
            <Dashboard />
          </SuspenseWrapper>
        ),
      },
      // Device routes sẽ xóa
      {
        path: 'devices/*',
        element: (
          <SuspenseWrapper>
            <Dashboard />
          </SuspenseWrapper>
        ),
      },
    ],
  },
  authRoutes,
  {
    path: '*',
    element: (
      <SuspenseWrapper>
        <NotFound />
      </SuspenseWrapper>
    ),
  },
]);

export default router;

